import { Toast } from 'zarm';
import { action } from '@iyunbao/cr-engine';
import config from '../../config';
import fetchAPI from '../../utils/fetchAPI';

interface smsProps {
  ticket: string;
  mobile?: string;
  fetchPhoneName?: string;
  factors: any;
  content: any;
  fetch: any;
  success: (e?: any) => void;
  fail: (e?: any) => void;
}

function sendSMS(params: smsProps) {
  const { fetchPhoneName, ticket, factors, mobile, content, fetch, success, fail } = params;
  let fetchParams: any = {
    url: `${config.iybtm.host}/util/sms.json`,
    method: 'POST',
    timeout: 7000,
  };
  const fetchData: any = {
    ticket,
    phone: mobile,
    mobile,
    platformId: 2,
  };

  // 附加因子
  if (factors) {
    fetchData.factors = factors;
  }

  // 附加参数
  if (content) {
    fetchData.content = content;
  }

  // 请求参数，自定义手机号key
  if (fetchPhoneName) {
    fetchData[fetchPhoneName] = mobile;
    delete fetchData.phone;
  }

  if (fetch) {
    const data = {
      ...fetchData,
      ...fetch.data,
    };

    fetchParams = {
      ...fetchParams,
      ...fetch,
      data,
    };
  } else {
    fetchParams.data = fetchData;
  }

  fetchAPI
    .fetchResult(fetchParams)
    // eslint-disable-next-line no-shadow
    .then((content) => {
      this.hasClick = false;

      if (!content || content.isSuccess || String(content.code) === '0') {
        const { result } = content || {};

        // 保司返回结果
        if (result && typeof result.code !== 'undefined' && String(result.code) !== '0') {
          fail && fail(content);

          if (result.errMsg || result.errorMsg) {
            if (typeof result.errMsg === 'string' || typeof result.errorMsg === 'string') {
              Toast.show({
                content: (result.errMsg || result.errorMsg),
                mask: true,
              });
            }

            if (Object.keys(result.errMsg) && Object.keys(result.errMsg).length) {
              const { type, data } = result.errMsg;

              if (action[type]) {
                action[type](data);
              }
            }
          }

          // Toast.show({
          //   content: (result.errMsg || result.errorMsg),
          //   mask: true,
          // });
          return false;
        }

        success(content);
        return false;
      }

      if (content) {
        fail && fail(content);

        if (content.errMsg || content.errorMsg) {
          if (typeof content.errMsg === 'string' || typeof content.errorMsg === 'string') {
            Toast.show({
              content: (content.errMsg || content.errorMsg),
              mask: true,
            });
          }

          if (Object.keys(content.errMsg) && Object.keys(content.errMsg).length) {
            const { type, data } = content.errMsg;

            if (action[type]) {
              action[type](data);
            }
          }
        }
      }
    })
    .catch((message) => {
      Toast.show({
        content: (message || '请求异常'),
        mask: true,
      });
    });
}

export default {
  sendSMS,
};
